export function formatUtcDateTime(date: Date): string {
  const iso = date.toISOString();
  return `${iso.slice(0, 19).replace("T", " ")} UTC`;
}

export function formatDistanceKm(km: number): string {
  if (km >= 1_000_000) return `${(km / 1_000_000).toFixed(3)} M km`;
  if (km >= 1_000) return `${(km / 1_000).toFixed(2)} mil km`;
  return `${km.toFixed(1)} km`;
}

export function formatSpeedKmS(kmS: number): string {
  return `${kmS.toFixed(3)} km/s`;
}

export function formatMassKg(massKg?: number): string {
  if (massKg == null) return "—";
  return massKg.toExponential(3) + " kg";
}
